import { isNumber } from 'lodash';
import { useTranslation } from '../../../../../translations';

export default function Timer({ quest_end_at }) {
  const { t } = useTranslation();

  if (!isNumber(quest_end_at)) return;

  const [day, month] = new Date(quest_end_at * 1000)
    .toLocaleDateString('ru-RU', { timeZone: 'Europe/Moscow' })
    .split('.');

  const value = t('other.until', { value: `${day}.${month}` });

  return <div className={'achievement__timer'}>{value}</div>;
}
